// @flow

import React from 'react';
import CoveImage from './CoveImage.jsx';

type ClipProps = {
  title: string,
  mezzanine: string,
  isPlaying: bool,
  handler: Function
};

export default function Clip(props: ClipProps) {
  return <div className="clip">
    <div className="clip-preview video-item-watchable" onClick={props.handler}>
      <div className="clip-thumbnail">
        <CoveImage
          alt={props.title}
          aspectRatio={0.5625}
          class="clip-image"
          imageSizes={{min: 100, max: 400, step: 100}}
          sizes={[{breakpoint: '1201px', width: '240px'}, {breakpoint: '769px', width: '20vw'},
            {breakpoint: '641px', width: '50vw'}, {breakpoint: '0', width: '100vw'}]}
          url={props.mezzanine}/>
        {props.isPlaying ?
          <div className="clip-playing">
            Now Playing
          </div> :
          <div className="play-button-width-wrapper">
            <div className="play-button-height-wrapper">
              <div className="play-button">
                <div className="play-arrow"/>
              </div>
            </div>
          </div>
        }
      </div>
      <div className="clip-title body-small">
        {props.title}
      </div>
    </div >
  </div>;
}